
	import { defineComponent, PropType } from 'vue';
	import { ZipCode } from '@/interfaces/ZipCode';
	import { IServerData } from '@/interfaces/Search';
	import { IEditable, IEntity } from '@/interfaces/Data';
	import { Alert, AlertType } from '@/interfaces/Notification';
	import { ApplicationService } from '@/services/ApplicationService';
	import { FormService } from '@/services/FormService';
	import { VForm } from 'vuetify/components'
	import { GlobalAlertService } from '@/services/GlobalAlertService';
	import { ApiResponse } from '@/interfaces/ApiResponse';
	import { BaseService } from '@/services/BaseService';
	import { VersionsStore } from '@/Stores/VersionStore';

	interface Data extends IServerData, IEditable<ZipCode> {
		progress: boolean,
		rulesZipCode: Array<(value: string) => {}>,
	}

	export default defineComponent({
		props: {
			propEntity: {
				type: Object as PropType<ZipCode>,
				default: null,
			},
			propController: {
				type: String,
				default: null,
			},
		},
		data(): Data {
			this.updateAlert();

			return {
				editableEntity: this.propEntity,
				controller: this.propController,
				progress: false,
				rulesZipCode: [
					value => {
						if (/^\d{5}$/.test(value)) return true;

						return 'Zip code must consist of five digits.'
					},
				]
			}
		},
		computed: {
		},
		watch: {
			propEntity(newValue, oldValue) {
				this.editableEntity = newValue;
			},
		},
		methods: {
			close() {
				this._close();
			},

			_close(entity?: ZipCode) {
				this.$emit("close-modal", entity);
			},

			updateAlert(alertType?: AlertType, message?: string) {
				GlobalAlertService.showAlert(alertType ? { type: alertType, message: message } as Alert : null);
			},

			trySave() {
				FormService.processIfValid(this.$refs.form as VForm, this.save, this.onError);
			},

			save() {
				this.updateAlert();
				this.progress = true;
				ApplicationService.updateEntity(this.editableEntity as IEntity, this.controller, this.onError)
					.then(json => {
						const response = json as ApiResponse<ZipCode>;
						if (response.errorMessage) {
							throw response;
						}
						VersionsStore.increment(this.controller);
						this.editableEntity = response.data;
						this._close(this.editableEntity as ZipCode);
					})
					.catch(reason => BaseService.processError(reason, this.onError))
					.finally(() => {
						this.progress = false;
					});
			},

			onError(error: string) {
				this.updateAlert(AlertType.error, error);
			},
		},
	})
